/* global PHOEBE_VERSION:false process:false module:false */

import "@babel/polyfill";
import React from "react";
import { createRoot } from "react-dom/client";
import $ from "jquery";
import Raven from "raven-js";

import { history } from "./router.jsx";

import { fetchConfig } from "./service/config.js";
import { clearModeratorToken, getModeratorToken } from "./service/auth.js";
import { applyTenantHead } from "./utils/tenant.js";

import Routes from "./components/Routes.jsx";

import "../../css/bs_overrides.scss";

// Page title + favicon for the current tenant (replaces react-helmet).
applyTenantHead();

// React 18: create the root once and reuse it. render() is called more than
// once (after fetchConfig resolves, in .always(), and on HMR), and calling
// createRoot() again on the same container is unsupported in React 18.
let root = null;
const render = () => {
	if(!root){
		root = createRoot(document.getElementById("root"));
	}
	root.render(<Routes/>);
};

// Attach the DRF token to each moderator API request. Login is deliberately
// excluded because it is the request that creates the token.
$.ajaxPrefilter(function(options, originalOptions, jqXHR){
	const requestUrl = options.url || "";
	const isModeratorApi = requestUrl.indexOf("/moderator/") !== -1 || requestUrl.indexOf("moderator/") === 0;
	const isLoginRequest = requestUrl.indexOf("/moderator/login_api") !== -1 || requestUrl.indexOf("moderator/login_api") === 0;
	const token = getModeratorToken();

	if(token && isModeratorApi && !isLoginRequest){
		jqXHR.setRequestHeader("Authorization", `Token ${token}`);
	}
});

$(document).ajaxError(function(event, jqXHR){
	if((jqXHR.status === 401 || jqXHR.status === 403) && history.location.pathname !== "/login"){
		clearModeratorToken();
		history.push("/login");
	}
});

// auto reload if client/server versions don't match
$(document).ajaxComplete(function(event, jqXHR, settings){
	if(jqXHR.status === 200 && settings.url.startsWith("/moderator") && jqXHR.getResponseHeader("X-Phoebe-Version") !== PHOEBE_VERSION){
		window.location.reload(true);
	}
});


fetchConfig().then((config) => {

	// Start Sentry logging if app is not in debug mode
	if(config.SENTRY_DSN && process.env.NODE_ENV === "production"){
		Raven.config(config.SENTRY_DSN, {
			release: config.PHOEBE_VERSION,
		}).install();

		//set the user context to identify the user
		Raven.setUserContext({
			user_email: config.USER_EMAIL,
			user_id: config.USER_ID,
			phoebe_version: config.PHOEBE_VERSION,
		});
	}

	render();
	if(module.hot){
		module.hot.dispose(function(){
			render();
		});
		module.hot.accept();
	}
}).always(() => render());
